// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__SNoHk","dragIcon":"Choice_dragIcon__owm-z","left":"Choice_left__1sd3_","input":"Choice_input__N6NwC"};